import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { EventType } from '@azure/msal-browser';
import { msalInstance } from './authConfig';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// msal-browser v3+ requires an explicit async initialize() before any other
// API call (including rendering MsalProvider) - see SCINFRA-686.
msalInstance.initialize().then(() => {
  // After a redirect back from Azure AD, make the newly signed-in account
  // the active one so acquireTokenSilent() (used by the API client) can find it.
  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const account = (event.payload as { account?: unknown }).account;
      if (account) {
        msalInstance.setActiveAccount(account as never);
      }
    }
  });

  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </MsalProvider>
    </React.StrictMode>
  );

  reportWebVitals();
});
